import { render } from "./Tabulator.vue?vue&type=template&id=62f2b5cb"
import script from "./Tabulator.vue?vue&type=script&lang=js"
export * from "./Tabulator.vue?vue&type=script&lang=js"

import "./Tabulator.vue?vue&type=style&index=0&id=62f2b5cb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__